import { ConfirmationService } from 'primeng/components/common/api';
import { LocalStorageService } from 'angular-2-local-storage';
import { Injectable, Injector } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '../user/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ResponseHandlerService {

  private static readonly DISABLE_GLOBAL_ERRORS = false;
  private translateService: TranslateService;

  constructor(
    private srvNotify: MessageService,
    private router: Router,
    private srvLocalStorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private injector: Injector
  ) { }

  handleOK(res: Response) {
    if (res.ok) {

      let data: any;
      const contentType: string = res.headers.get('content-type');

      if (contentType === 'application/octet-stream') {  // eccezione implementata per download excel
        data = res;
      } else {
        data = res.json();
      }

      if (data.rsp_code === 1005) {
        /*
       this.srvNotify.add({
         severity: 'warning',
         summary: "Warning",
         detail: "Token needs to refresh"
       });


       this.srvLocalStorage.remove('userData');
       sessionStorage.removeItem('userData');
       sessionStorage.removeItem('menu');
       this.router.navigateByUrl('login');
       */

        this.authService.logout();
        return data.rsp_msg;
      } else if (data.rsp_code === 7050777) {
        this.srvNotify.add({
          severity: 'warning',
          summary: 'Warning',
          detail: data.rsp_msg
        });
      } else if (data.rsp_code !== 0) {
        if (contentType === 'application/octet-stream') {  // eccezione implementata per download excel
          return data._body;
        }
        // Se ci sono violations, lancia l'intero oggetto data
        // così handleKO può accedere a rsp_data.violations
        if (data.rsp_data && data.rsp_data.violations && data.rsp_data.violations.length > 0) {
          const error: any = new Error(data.rsp_msg);
          error.rsp_data = data.rsp_data;
          error.rsp_msg = data.rsp_msg;
          error.rsp_code = data.rsp_code;
          error.rsp_metadata = data.rsp_metadata;
          throw error;
        }
        // Altrimenti funziona come prima
        throw new Error(data.rsp_msg);
      } else {
        return data.rsp_data;
      }
    } else {
      throw new Error('Unable to make request with server.');
    }
  }
  handleGetFileOK(res: Response) {
    if (res.ok) {
      let data: any;
      data = res;
      return data._body;
    } else {
      throw new Error('Unable to make request with server.');
    }
  }

  handleOKPaged(res: Response) {
    if (res.ok) {
      let data = res.json();
      if (data.rsp_code === 1005) {

        /*
          this.srvNotify.add({
            severity: 'warning',
            summary: "Warning",
            detail: "Token needs to refresh"
          });

          this.srvLocalStorage.remove('userData');
          sessionStorage.removeItem('userData');
          sessionStorage.removeItem('menu');
          this.router.navigateByUrl('login');
          */
        return data.rsp_msg;

      } else if (data.rsp_code === 7050777) {
        this.srvNotify.add({
          severity: 'warning',
          summary: 'Warning',
          detail: data.rsp_msg
        });
      } else if (data.rsp_code !== 0) {
        throw new Error(data.rsp_msg);
      } else {
        return { data: data.rsp_data, metadata: data.rsp_metadata };
      }
    } else {
      throw new Error('Unable to make request with server.');
    }
  }

  handleKO(error: Response | any) {

    let errMsg: string;
    let rsp_msg = null;
    let json_body = null;

    if (error instanceof Response) {
      // Prova sempre a parsare _body se esiste
      try {
        if ((error as any)._body) {
          json_body = JSON.parse((error as any)._body);
        }
      } catch (e) {
        // Fallback se non è JSON
        console.error('Error parsing response body:', e);
      }
      rsp_msg = json_body ? json_body.rsp_msg : ((error as any)._body || 'Unknown error');
    } else if (error && error.error) {
      json_body = error.error;
      rsp_msg = json_body.rsp_msg;
    } else if (error && error.rsp_data) {
      json_body = error;
      rsp_msg = json_body.rsp_msg;
    }

    if (json_body) {
      if (json_body.rsp_data && json_body.rsp_data.violations && json_body.rsp_data.violations.length > 0) {
        // Lazy load TranslateService per evitare dipendenze cicliche
        if (!this.translateService) {
          this.translateService = this.injector.get(TranslateService);
        }
        const violations = json_body.rsp_data.violations;
        const firstViolation = violations[0];
        if (violations.length > 1) {
          // più violations: mostra il messaggio del BE seguito dall'elenco completo
          const elenco = violations.map(v => `${v.field} (${v.violation})`).join(', ');
          rsp_msg = `${json_body.rsp_msg || this.translateService.instant('common.fieldError')}: ${elenco}`;
        } else {
          //rsp_msg = `${json_body.rsp_msg || "BAD_REQUEST"} ${this.translateService.instant('common.field')}: "${firstViolation.field}": "${firstViolation.violation}" }`;
          rsp_msg = `${this.translateService.instant('common.fieldError')} "${firstViolation.field}": "${firstViolation.violation}"`;
        }
      }

      if (json_body.rsp_code === 1005) {
        return Observable.of(false);
      }
    }

    if (error.status || (error.error && error.error.status)) {
      const status = error.status || error.error.status;
      errMsg = `${status} - ${rsp_msg || (error.message ? error.message : error.toString())}`;
    } else {
      errMsg = rsp_msg || (error.message ? error.message : error.toString());
    }

    return Observable.throw(errMsg);
  }
  handleOK_success(res: Response) {
    if (res.ok) {
      let data = res.json();
      if (data.rsp_code === 1005) {
        /*
          this.srvNotify.add({
            severity: 'warning',
            summary: "Warning",
            detail: "Token needs to refresh"
          });
        */
      } else if (data.rsp_code === 7050777) {
        this.srvNotify.add({
          severity: 'warning',
          summary: 'Warning',
          detail: data.rsp_msg
        });
      } else if (data.rsp_code !== 0) {
        throw new Error(data.rsp_msg);
      } else {
        return {
          success: true,
          data: data.rsp_data ? data.rsp_data : null,
          metadata: data.rsp_metadata ? data.rsp_metadata : null
        };
      }
    } else {
      throw new Error('Unable to make request with server.');
    }
  }
  handleGetFileKO(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = (error.status) ? error : error.json();
      let json_body = null;
      try {
        json_body = JSON.parse(body._body);
      } catch (e) {
        Observable.throw('Unable to parse JSON');
      }

      if (json_body) {
        body.rsp_msg = json_body.rsp_msg;

        if (json_body.rsp_code === 1005) {
          this.srvNotify.add({
            severity: 'warning',
            summary: "Warning",
            detail: "Token needs to refresh"
          });
          return Observable.of(false);
        }
      }
      errMsg = `${error.status} - ${body.rsp_msg || body._body}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }
  handle_KSS_OK_GET(res: Response) {
    if (res.ok) {
      let data: any;
      const contentType: string = res.headers.get('content-type');

      if (contentType === 'application/octet-stream') {  // eccezione implementata per download excel
        data = res;
      } else {
        data = res.json();
      }
      return data;
    } else {
      throw new Error('Unable to make request with server.');
    }
  }
  handle_KSS_OK_POST(res: Response) {
    if (res.ok) {
      let data: any;
      const contentType: string = res.headers.get('content-type');

      if (contentType === 'application/octet-stream') {  // eccezione implementata per download excel
        data = res;
      } else {
        data = res.json();
      }
      return data;
    } else {
      throw new Error('Unable to make request with server.');
    }
  }
  handle_KSS_OK_PUT(res: Response) {
    if (res && (res.ok || res.status == 204)) {
      return false;
    }
    else {
      throw new Error('Unable to make request with server.');
    }
  }
  handle_KSS_OK_PATCH(res: Response) {
    if (res && (res.ok || res.status == 204)) {
      return true;
    }
    else {
      throw new Error('Unable to make request with server.');
    }
  }
  handle_KSS_KO(error: Response | any) {
    // Cambio di contesto KSS
    let errMsg: string;
    if (error instanceof Response) {
      const body = (error.status) ? error : error.json();
      let json_body = null;
      try {
        json_body = JSON.parse(body._body);
      } catch (e) {
        Observable.throw('Unable to parse JSON');
      }

      if (json_body) {
        body.rsp_msg = json_body.rsp_msg;
      }
      errMsg = `${error.status} - ${body.rsp_msg || body._body}`;
      var self = this;
      if (error.ok == false && error.status == 426) {
        this.confirmationService.confirm({
          message: 'Context changed!',
          accept: () => {
            window.location.reload();
          },
          acceptLabel: "Ok",
          rejectVisible: false
        });
        return Observable.of(null);
      }

    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }
  displayErrors(errMsg) {
    console.error(errMsg);

    if (!ResponseHandlerService.DISABLE_GLOBAL_ERRORS) {
      this.srvNotify.add({ severity: 'error', summary: 'Error', detail: errMsg });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/httpClient/responseHandler.service.ts